import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/common/back.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("footer", null, "©TBS", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("header", null, [
      _withDirectives(_createVNode(_component_router_link, {
        to: { path: _ctx.backPage}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["to"]), [
        [_vShow, _ctx.backPage !='']
      ])
    ], 512), [
      [_vShow, _ctx.headerShow]
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          appear: "",
          name: "fade"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: route.name
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _hoisted_2
  ], 64))
}